import { PpIntroduction } from "@italymondo/core-ui";
import { CMSIntroductionData } from "./query";

export function formatData(data: CMSIntroductionData): PpIntroduction {
  if (!data.site) {
    throw new Error("Expected a site object");
  }

  return {
    media: data?.site?.serviceIndexPage[0].introMedia[0],
    mediaPlacement: data?.site?.serviceIndexPage[0].introMediaPlacement,
    paragraph: data?.site?.serviceIndexPage[0].introParagraph || "",
    shadowHeader: data?.site?.serviceIndexPage[0].introShadowHeader || "",
  };
}
